export default __webpack_public_path__ + "static/media/VisionClaimForm-for-Website.64845dd8.pdf";